import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close"; 
import { Tooltip } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: 300,
    sm: 500,
  },
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  p: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
};

const closeButtonStyle = {
  position: "absolute",
  top: -20,
  right: -20,
};

export default function InfoImage({title, image, }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Tooltip title={title}>
        <IconButton
          sx={{
            width: 24,
            height: 24,
            paddingBottom: 2,
            paddingLeft: 2
            
          }}
          onClick={handleOpen}
        >
          <InfoIcon sx={{width:20}} />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <Box sx={style}>
            <IconButton onClick={handleClose} sx={closeButtonStyle}>
              <CloseIcon
                sx={{
                  bgcolor: "black",
                  color: "white",
                  borderRadius: "50%",
                  width: 30,
                  height: 30,
                }}
              />
            </IconButton>
            <img
              src={image}
              alt="Logo"
              style={{ width: "100%", height: "auto" }}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
}